import type { PaymentLimitsTranslations } from "../interfaces/paymentLimits";

export const paymentLimitsTranslations: PaymentLimitsTranslations = {
  // Page
  page_title: "Amount limits",
  page_subtitle:
    "Per-operation minimum and maximum, by rail and payer kind, global or per organization, without deploys",
  refresh_button: "Refresh",
  refresh_aria: "Refresh the limits",
  why_banner:
    "An out-of-range amount is rejected on preview and on creation. Anything already in flight is untouched and settles normally.",

  // Scope selector
  scope_label: "Scope",
  scope_placeholder: "Search by name, email or ID…",
  scope_loading: "Loading organizations…",
  scope_empty: "No organizations found.",
  scope_searching: "Searching organizations…",
  scope_search_error: "We could not complete the search; showing the organizations already loaded.",
  scope_global_option: "Global (every organization)",
  scope_global_label: "Global",
  scope_global_hint: "Global scope: the limits every organization without its own override inherits.",
  scope_org_hint: "Changes here create an override for this organization, which wins over the global limits.",
  scope_catalog_error:
    "We could not load the organizations catalog; overrides may show IDs instead of names.",
  scope_catalog_truncated:
    "There are more organizations than listed; type to search them all. Some overrides may show the ID.",

  // KPI strip
  kpi_all: "Corridors",
  kpi_limited: "Limited",
  kpi_overrides: "With overrides",
  kpi_own_overrides: "With own override",

  // Table / cards
  section_payins: "Collections (payins)",
  section_payouts: "Payouts",
  th_rail: "Rail",
  th_country: "Country",
  th_currency: "Currency",
  th_person: "Individual",
  th_company: "Company",
  th_source: "Source",
  th_overrides: "Overrides",
  direction_payin: "Payins",
  direction_payout: "Payouts",
  country_ar: "Argentina",
  country_br: "Brazil",
  country_co: "Colombia",
  country_mx: "Mexico",
  bound_min: "Min",
  bound_max: "Max",
  bound_none: "No limit",
  payer_both: "Both",
  payer_person: "Individual",
  payer_company: "Company",
  source_default: "No limit configured",
  source_global_setting: "Global limit",
  source_global: "Inherited from global",
  source_org_override: "Organization override",
  overrides_count: "{{count}} overrides",
  overrides_count_one: "1 override",
  overrides_count_other: "{{count}} overrides",
  overrides_popover_hint: "Tap an organization to open its view and manage its override.",
  action_edit: "Edit",
  action_remove: "Remove limit",
  action_clear_override: "Remove override",
  empty_title: "No corridors to show",
  empty_description: "No corridor matches the selected filter.",

  // Edit dialog
  dialog_title: "{{rail}} limits",
  dialog_scope_global: "Applies to every organization without its own override.",
  dialog_scope_org: "Creates an override for the selected organization only.",
  dialog_consequence:
    "From the moment you save, an amount outside this range is rejected on preview and on creation. Anything already in flight is untouched.",
  payer_type_label: "Applies to",
  payer_type_hint:
    "A row for one payer kind wins over the “Both” row. On PSE the payer declares whether they are an individual or a company; on the other rails it is inferred from the document.",
  min_label: "Minimum per operation",
  max_label: "Maximum per operation",
  unbounded_placeholder: "No limit",
  reason_label: "Reason (optional)",
  reason_placeholder: "E.g. network cap for individuals",
  reason_internal_hint:
    "The reason is internal: only the Coloca team sees it. The client sees the generic message with the limit.",
  validation_money: "Enter a valid amount.",
  validation_at_least_one: "Enter at least a minimum or a maximum.",
  validation_min_below_max: "The minimum must be lower than the maximum.",
  validation_fraction_digits: "{{currency}} allows up to {{digits}} decimals.",
  dialog_cancel: "Cancel",
  dialog_submit: "Save limit",

  // Remove dialog
  clear_title: "Remove the limit",
  clear_description: "The corridor will have no limit configured at the global scope.",
  clear_override_description:
    "The organization will inherit this corridor's global limits again (or have none).",
  clear_rows_intro: "These rows will be removed:",
  clear_confirm: "Remove",
  clear_cancel: "Cancel",

  // Toasts / errors
  toast_saved: "{{rail}} limit saved.",
  toast_cleared: "{{rail}} limit removed.",
  error_load: "We could not load the limits.",
  error_load_detail: "Check your connection and try again.",
  error_retry: "Retry",
  error_save: "We could not save the change.",
  error_no_write_permission: "Your user has no write permission on payments.",
};
